import React, { useState } from "react";
import { Box, Button, Paper } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";

const integrations = {
  HTML: `<iframe onclick="alert('Button Clicked!')">Click Me</iframe>`
};

const IntegrationTab = () => {
  const [copied, setCopied] = useState(false);



  const handleCopy = () => {
    navigator.clipboard.writeText(integrations.HTML)
      .then(() => setCopied(true))
      .catch(() => alert("Failed to copy text"));
  };

  return (
    <Box sx={{ width: "100%", typography: "body1"}}>
      <Paper elevation={3} sx={{ p: 2, position: "relative" }}>
        <pre style={{ background: "#f5f5f5", padding: "12px", borderRadius: "8px", overflowX: "auto" }}>
          <code>{integrations.HTML}</code>
        </pre>

        <Button
          startIcon={<ContentCopy />}
          variant="contained"
          size="small"
          onClick={handleCopy}
          sx={{ position: "absolute", top: 10, right: 10 }}
        >
          {copied ? "Copied!" : "Copy"}
        </Button>
      </Paper>
    </Box>
  );
};

export default IntegrationTab;
